import { useModules } from '@contexts/modules-provider';
import { APP_ROUTES } from '@routes/routes.constants';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

/**
 * Guards visitor-only routes (e.g. /home).
 *
 * Visitors are B2C users with no modules assigned.
 * Users with modules are redirected to AppInitializer to resolve their correct landing page.
 * This handles stale deep links (e.g. cached /home URL) that may arrive post-refactor.
 *
 * Note: B2E (internal) users always have at least 1 module (Instruct/Manage),
 * so they are blocked by the module check — no separate isInternalUser check needed.
 */
const VisitorGuard = React.memo((): React.ReactElement => {
  const { modules, isModulesLoading } = useModules();

  if (isModulesLoading) {
    return <AppLoader />;
  }

  if (modules && modules.length > 0) {
    return <Navigate to={APP_ROUTES.APP_INITIALIZER} replace />;
  }

  return <Outlet />;
});

VisitorGuard.displayName = 'VisitorGuard';

export { VisitorGuard };
